import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, IonicPage, AlertController } from 'ionic-angular';
import { LoginProvider } from '../../providers/login';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Validator } from '../../validator';
import { QrscannerPage } from '../qrscanner/qrscanner';
import { CheckpinPage } from '../checkpin/checkpin';
import { GuestdashboardPage } from '../guestdashboard/guestdashboard';
import { Settings } from '../../settings';
@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})

export class LoginPage {

  private checklogin: any;
  private mode: string;
  private emailPasswordForm: FormGroup;
  private emailForm: FormGroup;
  email: string = '';
  private appVersion = Settings.appVersion;

  constructor(public navCtrl: NavController, public loginProvider: LoginProvider, public formBuilder: FormBuilder, public modalCtrl: ModalController, private alertCtrl: AlertController, public navParams: NavParams) {

    if(this.navParams.get("checklogin") == false) {
        this.checklogin = false;
    } else {
        this.checklogin = true;
    }

    // It's important to hook the navController to our loginProvider.
    this.loginProvider.setNavController(this.navCtrl);
    // Create our forms and their validators based on validators set on validator.ts.
    this.emailPasswordForm = formBuilder.group({
      email: Validator.emailValidator,
      password: Validator.passwordValidator
    });
    this.emailForm = formBuilder.group({
      email: Validator.emailValidator
    });


  }

  ionViewDidEnter() {

  }

  ionViewWillLeave() {

  }

  ionViewDidLoad() {
    // Set view mode to main.
    this.mode = 'main';

    if(this.checklogin == true) {
        this.loginProvider.checkLogin();
    }

  }

  // Call loginProvider and login the user with email and password.
  // You may be wondering where the login function for Facebook and Google are.
  // They are called directly from the html markup via loginProvider.facebookLogin() and loginProvider.googleLogin().
  login() {
    let username = this.emailPasswordForm.value["email"].replace(/\s/g, '');
    let password = this.emailPasswordForm.value["password"];
    this.loginProvider.emailLogin(username, password);
  }

  // Clear the forms.
  clearForms() {
    this.emailPasswordForm.reset();
    this.emailForm.reset();
  }

  startPinCodeRegister() {
      let alert = this.alertCtrl.create({
          title: 'PIN-Code Registrierung',
          message: 'Bitte den PIN-Code zur Registrierung bereithalten.',
          buttons: [
              {
                  text: 'Abbrechen',
                  role: 'cancel',
                  handler: () => {

                  }
              },
              {
                  text: 'Los gehts',
                  handler: () => {
                      this.navCtrl.push(CheckpinPage);
                  }
              }
          ]
      });
      alert.present();
  }
  startQRregister() {
    let alert = this.alertCtrl.create({
        title: 'QR-Code Registrierung',
        message: 'Bitte den QR-Code zur Registrierung bereithalten.',
        buttons: [
            {
                text: 'Abbrechen',
                role: 'cancel',
                handler: () => {

                }
            },
            {
                text: 'Los gehts',
                handler: () => {
                    this.navCtrl.push(QrscannerPage);
                }
            }
        ]
    });
    alert.present();
  }

  loginAsGuest() {
      let alert = this.alertCtrl.create({
          title: 'Anmeldung',
          message: 'Registrierte Nutzer sehen mehr',
          buttons: [
              {
                  text: 'Abbrechen',
                  role: 'cancel',
                  handler: () => {

                  }
              },
              {
                  text: 'Los gehts',
                  handler: () => {
                      this.navCtrl.setRoot(QrscannerPage);
                  }
              }
          ]
      });
      alert.present();
  }


  showGuestArea() {
      this.navCtrl.setRoot(GuestdashboardPage);
  }

  checkEmailWhitespace() {

  }

  forgetPasswort() {
    this.loginProvider.forgetPasswort();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts